import { DOCUMENT, inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ConfigService } from '../config.service';

export enum TrackingEvent {
  share = 'Partage',
}

export enum TrackingAction {
  download = 'Télécharger',
  copy = 'Copier',
}

interface MatomoWindow extends Window {
  _paq?: unknown[];
}

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  private readonly _title: Title = inject(Title);
  private readonly _config: ConfigService = inject(ConfigService);
  private readonly _document: Document = inject<Document>(DOCUMENT);

  private get _paq(): unknown[] {
    const window: MatomoWindow = this._document.defaultView as MatomoWindow;
    window._paq = window._paq ?? [];

    return window._paq;
  }

  public bootstrap(): void {
    this._paq.push(
      ['setTrackerUrl', this._config.configuration?.matomo + '/matomo.php'],
      ['setSiteId', this._config.configuration?.matomoSiteId]
    );

    const script: HTMLElement = this._document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('async', 'true');
    script.setAttribute(
      'src',
      this._config.configuration?.matomo + '/matomo.js'
    );
    this._document.head.appendChild(script);
  }

  public trackPage(): void {
    const window: MatomoWindow = this._document.defaultView as MatomoWindow;
    const url: string =
      (window?.location?.pathname ?? '') + (window?.location?.search ?? '');

    // Track
    this._paq.push(
      ['deleteCustomVariables', 'page'],
      ['deleteCustomDimension', 1],
      ['setCustomUrl', url],
      ['setDocumentTitle', this._title.getTitle()],
      // ['setReferrerUrl', {{Referrer}}],
      ['trackPageView']
    );
  }

  public trackEvent(
    category: TrackingEvent,
    action: TrackingAction,
    name: string,
    value?: string
  ): void {
    this._paq.push(['trackEvent', category, action, name, value]);
  }
}
